import { WindowService } from './../../services/window-dialogs/window.service';
import { Component, OnInit } from '@angular/core';
import { DialogService } from '../../../app/services/modal-dialogs';
import { GlobalService } from '../../services/global.service';
import { ssApiService } from '../../services/ss-api.service';
import { LicenseManager } from '../../managers/License.manager';
import { SortBot } from '../../helpers/sort';
import { GetBenchmarksRequest } from '@models/ss-api/requests/get.benchmarks.request';
import { VideoCardBenchmarkItemArray } from '@models/domain/video.card.benchmark.item';
import { UpdateGPUBenchmarkDialog } from 'app/dialogs/update.gpubenchmark/update.gpubenchmark.dialog';

@Component({
    selector: 'update-gpubenchmarks',
    templateUrl: './update.gpubenchmarks.component.html',
    styleUrls: ['./update.gpubenchmarks.component.scss']
})

export class UpdateGPUBenchmarksComponent implements OnInit {
    IsBusy: boolean = false;

    GPUBenchmarks: VideoCardBenchmarkItemArray;
    GPUBenchmarksFilter: string;

    UnknownOnly: boolean = false;

    resultRows: number = 25;
    firstResult: number = 0;
    lastResult: number = 24;

    constructor(private dialogService: DialogService, private gb: GlobalService, private api: ssApiService, private windowService: WindowService) { }

    ngOnInit() {
        this.gb.SetPageTitle('GPU Benchmarks');
        // this.IsBusy = true;
        this.LoadGPUBenchmarks();
    }

    BenchmarkSite(){
        let newTab = window.open();

        newTab.location.href = 'https://www.videocardbenchmark.net/GPU_mega_page.html';
    }

    LoadGPUBenchmarks() {
        this.IsBusy = true;

        var request = new GetBenchmarksRequest();
        request.IncludeCPUs = false;
        request.IncludeVideoCards = true;
        request.MissingValuesOnly = this.UnknownOnly;

        let disposable = this.api.GetBenchmarks(request).subscribe(response => {
            this.IsBusy = false;
            this.GPUBenchmarks = response.Data.VideoCardBenchmarkItems;
            console.log("gbm", this.GPUBenchmarks);
            disposable.unsubscribe();
        });
    }
   
    paginateBenchmarks(e) {
        // console.log("paginateSearch :", e);
        this.firstResult = e.page * e.rows;
        this.lastResult = this.firstResult + e.rows;
    } 

    AddGPUBenchmark() {
        let disposable = this.dialogService.addDialog(UpdateGPUBenchmarkDialog, {
            Title: 'Add GPU Benchmark'
        }, { width: 600, height: 600 }).subscribe(response => {
            disposable.unsubscribe();
            if (response) {
                this.LoadGPUBenchmarks();
            }
        });
    }

    EditGPUBenchmark(gpuBenchmark) {
        let disposable = this.dialogService.addDialog(UpdateGPUBenchmarkDialog, {
            Title: 'Edit CPU Benchmark',
            GPUBenchmark: gpuBenchmark
            //CPUBenchmarkItem: cpuBenchmark
        }, { width: 600, height: 650 }).subscribe(response => {
            disposable.unsubscribe();
            if (response) {
                this.LoadGPUBenchmarks();
            }
        });
    }
   
    ToggleUnknownOnly() {
        this.UnknownOnly = !this.UnknownOnly;
        this.LoadGPUBenchmarks();
    } 

    SortBy( sortVar1: string, sortVar2: string = '' ) {
        this.GPUBenchmarks = SortBot.SortAuto( this.GPUBenchmarks, sortVar1, sortVar2);
    }

    onSearchTable(term) {
        this.GPUBenchmarksFilter = term;
    }
}
